import { useTranslation } from '@crehana/i18n';

import type { LearnDashboardLocaleKeys } from '../types';

export const useCrehanaTranslation = () => {
  const { t, ...others } = useTranslation<LearnDashboardLocaleKeys>();

  return { t, ...others };
};
